/*
 * AppConstants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here. We prefix them with 'yourproject/YourComponent' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'yourproject/YourContainer/YOUR_ACTION_CONSTANT';
 */

export const DATE_TYPE = 'date';
export const EXACT_TYPE = 'exact';
export const DROPDOWN_TYPE = 'dropdown';
export const RANGE_TYPE = 'range';
export const TYPE = 'type';
export const VAR = 'var';
export const VALUE1 = 'value1';
export const VALUE2 = 'value2';
export const UNKNOWN = 'unknown';
